import * as React from 'react'
import Box from '@mui/material/Box'
import LinearProgress from '@mui/material/LinearProgress'

export function Pending() {
  return (
    <Box pt={2} pb={0}>
      <LinearProgress variant="query" />
    </Box>
  )
}
